export default __webpack_public_path__ + "static/media/DSC_0502.65a01d2f.jpg";